'use client'

import { useQuery } from '@urql/next'
import { useContext } from 'react'
import { AppLayoutContext } from '~/app/_components'
import { SearchResultPageInnerDesktop } from './desktop/DesktopResults'
import { SearchResultPageInnerMobile } from './mobile/MobileResults'
import { graphql } from '~/generated/gql'
import type { TrimmedAccountFragment } from '~/generated/graphql'
import { AccountsFilterContext } from '.'
import { AccountPreset } from '~/generated/types'

const GetHandpickedAccounts = graphql(/* GraphQL */ `
  query GetHandpickedAccounts {
    curatedAccounts {
      account {
        ...TrimmedAccount
      }
    }
  }
`)

export function HandpickedAccounts() {
  const { searchQuery } = useContext(AccountsFilterContext)

  const { mobile } = useContext(AppLayoutContext)
  const Inner = mobile ? SearchResultPageInnerMobile : SearchResultPageInnerDesktop

  const [{ data }] = useQuery({
    query: GetHandpickedAccounts,
    pause: searchQuery.preset !== AccountPreset.WithoutCurated,
  })

  if (searchQuery.preset === AccountPreset.Default) return null
  if (!data?.curatedAccounts) return null

  const edges = data.curatedAccounts
    .filter((curated): curated is { account: TrimmedAccountFragment } => !!curated.account)
    .map((curated) => ({
      node: curated.account,
      cursor: curated.account.id,
    }))

  return <Inner edges={edges} />
}
